const data = {
  states: [
    { value: 'enable', description: 'Ativo' },
    { value: 'canceled', description: 'Cancelado' },
    { value: 'pending', description: 'Pendente' },
    { value: 'overdue', description: 'Inadimplente' }
  ],
  cancellationOrigins: [
    { value: 'automatic', description: 'Automático (atraso de parcela)' },
    { value: 'manual', description: 'Manual' }
  ]
};

export default {
  states: _.orderBy(data.states, [item => item.description]),
  cancellationOrigins: data.cancellationOrigins
};
